<template>
  <div id="countdown-container" class="flex items-center">
    <VIcon v-if="showIcon" icon="timer" class="mr-1 material-icons-outlined" size="16" />
    <p data-testid="display-time">
      <span v-if="prefix">{{ prefix }}</span>
      {{ formattedTime }}
      <span v-if="suffix">{{ suffix }}</span>
    </p>
  </div>
</template>

<script setup lang="ts">
import useTimer, { type TimerMode } from '@/composables/useTimer'
import useTimeParser from '@/composables/useTimeParser'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import useDateUtils from '@/composables/useDateUtils'

interface Props {
  prefix?: string
  suffix?: string
  startAt?: string | null
  endAt?: string | null
  showIcon?: boolean
  timerMode: TimerMode
}

const { endAt, showIcon = true, startAt, timerMode } = defineProps<Props>()

const { safeParseISO } = useDateUtils()
const { t } = useI18n()
const { duration } = useTimer(timerMode, {
  startAt: startAt ? safeParseISO(startAt) : undefined,
  endAt: endAt ? safeParseISO(endAt) : undefined
})

const { formatDurationTime } = useTimeParser()
const formattedTime = computed(() =>
  duration.value ? formatDurationTime(duration.value) : `0 ${t('sec.')}`
)
</script>

<style scoped></style>
